export default __webpack_public_path__ + "static/media/v5.cef8289f.svg";